module.exports = __webpack_public_path__ + "img/BlinkArt_Mace1H_Basic.899a8ed9.png";